import useJumboAuth from "@jumbo/hooks/useJumboAuth";
import { USER_ROLES } from "app/utils/constants/constants";

const useAdmin = () => {
  const { authUser } = useJumboAuth();
  return authUser?.authorities?.includes(USER_ROLES.ROLE_ADMIN) || false;
};

export default useAdmin;
